import { HTMLInputTypeAttribute } from "react";

type TextInputProps = {
  isMandatory?: boolean;
  type?: HTMLInputTypeAttribute;
  pattern?: string;
  minLength?: number;
  maxLength?: number;
  min?: number;
  max?: number;
  labelText?: string;
  inputText?: string | number;
  isDisabled?: boolean;
  theme?: string;
  name?: string;
  setInputText(inputText: string): void;
};

const CommonTextInput = (props: TextInputProps) => {

  return (
    <div className="input-container input-container-text flex flex-col h-full">
      <input
        id={props.labelText}
        name={props.name || props.labelText}
        type={props.type}
        pattern={props.pattern}
        minLength={props.minLength}
        maxLength={props.maxLength}
        min={props.min}
        max={props.max}
        value={props.inputText}
        onChange={(e) => props.setInputText(e.target.value)}
        className={`text-blueH1 border rounded-cornerMob text-xl md:text-2xl pl-4 md:pl-6 h-full ${props.theme === 'orange' ? 'border-orangeH3 ' : 'border-blueH1 '}`}
        required
        disabled={props.isDisabled} />
      {
        props.type !== 'date' ?
          <label className={`label ${props.inputText ? 'filled' : ''}`} htmlFor={props.labelText}>
            {props.labelText}{props.isMandatory ? '*' : ''}
          </label> : null
      }
    </div>
  );
};

export default CommonTextInput;